import compose from 'compose-function'
import { withRedux } from './with-redux'
import { withConnectedRouter } from './with-connected-router'
import { withApi } from './with-api'

export const withProviders = compose(withRedux, withApi, withConnectedRouter)
